import { IOrderLocationsGroup } from "./venueAreas.reducer";


export const SET_VENUE_AREA = "SET_VENUE_AREA";

export function setVenueAreas(data: Record<string , IOrderLocationsGroup>) {
    return {
        type: SET_VENUE_AREA,
        payload: data
    };
}
export const ADD_VENUE_AREA = "ADD_VENUE_AREA";

export function addVenueArea(data: any) {
    return {
        type: ADD_VENUE_AREA,
        payload: data
    };
}
export const UPDATE_VENUE_AREA = "UPDATE_VENUE_AREA";

export function updateVenueArea(data: any) {
    return {
        type: UPDATE_VENUE_AREA,
        payload: data
    };
}
export const DELETE_VENUE_AREA = "DELETE_VENUE_AREA";

export function deleteVenueArea(id: string) {
    return {
        type: DELETE_VENUE_AREA,
        payload: id
    };
}

